module.exports = __webpack_public_path__ + "static/img/dzp4.307fe8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dzp4.png
// module id = 0EqN
// module chunks = 1